import React, { createContext, useContext, useState, useEffect } from 'react';

const MockUserContext = createContext(null);

export const MockUserProvider = ({ children }) => {
	const [users, setUsers] = useState([]);
	const [currentUserId, setCurrentUserIdState] = useState(
		() => localStorage.getItem('mockUserId') || ''
	);

	useEffect(() => {
		fetch('/mock-users.json')
			.then((r) => r.json())
			.then((data) => {
				setUsers(data);
				setCurrentUserIdState((prev) => {
					if (prev && data.some((u) => u.id === prev)) return prev;
					const first = data[0]?.id || '';
					localStorage.setItem('mockUserId', first);
					return first;
				});
			})
			.catch(() => {});
	}, []);

	const setCurrentUserId = (id) => {
		localStorage.setItem('mockUserId', id);
		setCurrentUserIdState(id);
	};

	return (
		<MockUserContext.Provider value={{ users, currentUserId, setCurrentUserId }}>
			{children}
		</MockUserContext.Provider>
	);
};

export const useMockUser = () => useContext(MockUserContext);
